import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const LOGO = "https://customer-assets-lxgj4vgw.emergentagent.net/job_daab-recruit/artifacts/kveh0gcx_file_0000000029048211809fc80c6002540d.webp";

export const PageHeader = ({ backLabel = "Back to site" }) => (
  <header className="sticky top-0 z-50 bg-white/85 backdrop-blur-md border-b border-[#e4e4e7]">
    <div className="max-w-[1600px] mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
      <a href="/" className="shrink-0">
        <img src={LOGO} alt="DAAB Consulting Recruitment Services" className="h-9 md:h-11 w-auto object-contain" />
      </a>
      <div className="flex items-center gap-4 font-body text-sm">
        <Link to="/employers" className="text-[#52525b] hover:text-[#0a0a0a]">Employers</Link>
        <Link to="/candidates" className="text-[#52525b] hover:text-[#0a0a0a]">Candidates</Link>
        <Link to="/" className="inline-flex items-center gap-2 text-[#52525b] hover:text-[#0a0a0a]">
          <ArrowLeft size={16} /> {backLabel}
        </Link>
      </div>
    </div>
  </header>
);
